import React from "react";

export default {
  slug: "networks",
  endpoint: "networks/",
  titleKey: "networks_title",
  columns: [
    { label: "f_logo", format: row => (row.image ? React.createElement("img", { src: row.image, className: "pt-image-thumb", alt: "" }) : "—") },
    { field: "name", label: "f_name" },
    { field: "code", label: "f_code" },
  ],
  fields: [
    { name: "image", type: "image", label: "f_logo", wide: true },
    { name: "name", type: "text", label: "f_name", required: true },
    { name: "code", type: "text", label: "f_code" },
  ],
  injectOnCreate: (item, me) => ({ ...item, company: me && me.company ? me.company.id : null }),
  softDelete: true,
};
